/**
 * External Dependencies
 */
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

window.addEventListener('load', () => {
  document.body.classList.add('js-loaded');
})

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

window.onload = () => {
  routes.loadEvents();
}

